import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import StyledCheckbox from "@components/forms/StyledCheckbox";
import { acceptTerms } from "@components/validation";
import PayPalSellButton from "./PayPalSellButton";
import {
  ClearedStyleRealButton,
  ClearedStyleHref,
  ClearedStyleRouterLink
} from "@modules/Components";
import { currencyFormatter } from "@utils";
import { getSellCardsTotals } from "@modules/Sell/selector";
import { submit } from "redux-form";

const CheckboxContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;

  @media (max-width: 950px) {
    margin-top: 2px;
  }
`;

const SubmitButton = styled.div`
  @media (min-height: 700px) and (min-width: 950px) {
    max-width: 285px;
  }
`;

const Button = styled(ClearedStyleRealButton)`
  cursor: ${props => (props.valid ? "pointer" : "not-allowed")};
  width: 100%;
  height: 72px;
  border-radius: 36px;
  box-shadow: ${props =>
    props.valid ? "0 9px 18px 0 rgba(57, 200, 118, 0.3)" : "none"};
  background-color: ${props => (props.valid ? "#39c876" : "#f2f2f3")};
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: ${props => (props.valid ? "#ffffff" : "rgba(119, 121, 132, 0.5)")};
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    box-shadow: none;
    background-color: ${props => (props.valid ? "#39c876" : "#f2f2f3")};
  }

  @media (max-height: 730px) {
    height: 60px;
  }
  @media (max-height: 600px) {
    height: 50px;
  }
  @media (max-height: 575px) {
    height: 40px;
  }
`;

const PaypalButtonForDefault = styled.div`
  width: 100%;
  min-height: 40px;
  position: relative;
  height: 40px;
  isolation: isolate;

  @media (max-width: 950px) {
    min-height: 55px;
    height: 55px;
  }
`;

const AbsolutePaypalCover = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: red;
  z-index: 201;
  background-color: white;
  mix-blend-mode: color;
  cursor: not-allowed;
  display: ${props => (props.disableButton ? "initial" : "none")};
`;

const TradeSpan = styled.span`
  display: flex;
  align-items: center;
`;

const TradeAmount = styled.span`
  margin-right: 20px;
`;

const TradeImage = styled.img`
  width: 38px;
  height: 24px;
  mix-blend-mode: ${props => (props.disableButton ? "luminosity" : "normal")};

  @media (max-width: 950px) {
    width: 57px;
    height: 36px;
  }
`;

const TermsAndConditions = styled.div`
  font-size: 11px;
  color: #777984;
  margin-top: 10px;

  @media (max-width: 950px) {
    text-align: center;
  }
`;

const TermsLink = styled(ClearedStyleRouterLink)`
  color: #12b2ea !important;
  font-weight: 500;
  cursor: pointer;
`;

const Href = styled.span`
  color: #1f2021;
`;

const GridContainer = styled.span`
  @media (min-height: 700px) and (max-width: 950px) {
    width: 100%;
    display: grid;
  }
`;

const SellOrderSellButton = ({
  payoutType,
  payoutMethod,
  reduxFormDispatch,
  valid,
  checkout,
  orderInfo,
  missingInfo,
  paypalButtonClass,
  img
}) => {
  const [paypalReady, setPaypalReady] = useState(false);
  useEffect(() => {
    if (globalThis?.paypal?.Button) {
      setPaypalReady(true);
    }
  }, [globalThis?.paypal?.Button]);
  return (
    <>
      <GridContainer>
        <CheckboxContainer>
          <StyledCheckbox
            name={"acceptTerms"}
            text={
              <span>
                I accept the{" "}
                <TermsLink to="/tos/">terms and conditions</TermsLink>.
              </span>
            }
            validate={acceptTerms}
          />
        </CheckboxContainer>
        <SubmitButton>
          {payoutType === "Paypal" ? (
            <PaypalButtonForDefault
              onClick={() => reduxFormDispatch(submit("payPalSell"))}
            >
              <AbsolutePaypalCover disableButton={!(valid && !missingInfo)} />
              {paypalReady && (
                <PayPalSellButton paypalButtonClass={paypalButtonClass} />
              )}
            </PaypalButtonForDefault>
          ) : (
            <Button
              type="submit"
              valid={valid && !missingInfo}
              disabled={missingInfo}
            >
              {checkout.submitDisabled ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                <span>
                  {payoutMethod === "TRADEOPTION" ? (
                    <TradeSpan>
                      <TradeAmount>
                        Get {currencyFormatter(orderInfo.total)} Gift Card
                      </TradeAmount>
                      <TradeImage
                        src={img}
                        disableButton={!(valid && !missingInfo)}
                        alt="trade image"
                      />
                    </TradeSpan>
                  ) : (
                    `Get ${currencyFormatter(orderInfo.total)} Cash`
                  )}
                </span>
              )}
            </Button>
          )}
        </SubmitButton>
      </GridContainer>
      <TermsAndConditions>
        <span>By continuing, you agree to the</span>
        <Href>
          <ClearedStyleHref href="https://cardcash.com/tos/" target="_blank">
            &nbsp;Terms
          </ClearedStyleHref>
        </Href>
        &nbsp;and&nbsp;
        <Href>
          <ClearedStyleHref
            href="https://cardcash.com/privacy-policy/"
            target="_blank"
          >
            Privacy
          </ClearedStyleHref>
        </Href>
      </TermsAndConditions>
    </>
  );
};

export default connect(state => ({
  payoutMethod: state.cartSell.payoutMethod,
  payoutType: state.cartSell.payoutType,
  checkout: state.checkout,
  orderInfo: getSellCardsTotals({
    cart: state.cartSell,
    cards: state.cards
  })
}))(SellOrderSellButton);
